import axios from '../../axiosConfig';
import { truncateEmail } from '../../Utilities/utils';

export const updateOrderStatus = async ({
	status,
	orderDetailId,
	token,
	accounts,
}) => {
	if (!token || !orderDetailId) throw new Error('Missing token or values data');

	const updateUrl = `/updateOrderStatus/${encodeURIComponent(orderDetailId)}?esoiStatusId=${encodeURIComponent(status)}&Author=${encodeURIComponent(truncateEmail(accounts[0].username, 50))}`;
	const response = await axios.put(updateUrl, null, {
		headers: {
			Authorization: token,
			'Content-Type': 'application/json',
		},
	});

	return response.status;
};
